import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import FuturesGraphMobile from '../../pages/markets/component/futures-graph-mobile';
import { FuturesGraph } from '../futures-graph-widget/futures-graph';

const FuturesGraphWidget = () => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <FuturesGraphMobile />
    </QueryClientProvider>
  );
};

export { FuturesGraphWidget }
